import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/Style.css';
import './assets/css/responsive.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Header from './component/Header';
import Home from './pages/Home';
import DetailsPage from './pages/DetailsPage';
import Profile from './pages/Profile';
import Notifications from './pages/Notifications';
import BottomHeader from './component/BottomHeader';
import MobileHeader from './component/MobileHeader';
import Filter from './pages/Filter';
import { FilterProvider } from './context/FilterContext';
import AddFilter from './pages/AddFilter';
import EditFilter from './pages/EditFilter';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import Signup from './pages/Signup';
import './i18n';
import Favorites from './pages/Favorites';
import FilterList from './pages/FilterList';
// Array of routes where header should be hidden
const routesWithoutHeader = [
  '/details',
  '/notifications',
  '/',
  '/forgot-password',
  '/signup',
  // Add more page paths here to hide header
];

// Array of routes where header should be hidden
const routesWithoutMobileHeader = [
  '/details',
  '/forgot-password',
  '/',
  '/signup',
  '/profile',
  // Add more page paths here to hide header
];

// Array of routes where header should be hidden
const routesWithoutBottomHeader = [
  '/details',
  '/notifications',
  '/add-filter',
  '/edit-filter',
  '/filter-list',
  '/forgot-password',
  '/',
  '/signup',
  // Add more page paths here to hide header
];

const isAuthenticated = () => {
  const userID = localStorage.getItem('userID');
  const agentKey = localStorage.getItem('agentKey');
  return Boolean(userID && agentKey);
};

function ProtectedRoute({ children }) {
  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function AppContent() {
  const location = useLocation();
  const shouldHideHeader = routesWithoutHeader.includes(location.pathname);
  const shouldHideBottomHeader = routesWithoutBottomHeader.includes(location.pathname);
  const shouldHideMobileHeader = routesWithoutMobileHeader.includes(location.pathname);
  const [transferProps, setTransferProps] = useState();
  return (
    <>
      {!shouldHideHeader && <Header />}
      {!shouldHideMobileHeader && <MobileHeader />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/details"
          element={
            <ProtectedRoute>
              <DetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <Notifications />
            </ProtectedRoute>
          }
        />
        <Route
          path="/filter"
          element={
            <ProtectedRoute>
              <Filter />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-filter"
          element={
            <ProtectedRoute>
              <AddFilter />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-filter"
          element={
            <ProtectedRoute>
              <EditFilter />
            </ProtectedRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />
        <Route
          path="/favorites"
          element={
            <ProtectedRoute>
              <Favorites />
            </ProtectedRoute>
          }
        />
        <Route
          path="/filter-list"
          element={
            <ProtectedRoute>
              <FilterList />
            </ProtectedRoute>
          }
        />
      </Routes>

      {!shouldHideBottomHeader && <BottomHeader />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Router basename={process.env.PUBLIC_URL}>
        <FilterProvider>
          <AppContent />
        </FilterProvider>
      </Router>
    </div>
  );
}

export default App;

